import { useState, useEffect } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import RegiondoBookingCardBase from '../common/RegiondoBookingCardBase';
import useBooking from '../../../../hooks/useBooking';
import { toast } from 'react-toastify';

function BookingCardLasertag({ booking, updateBookingState, slotMode }) {
  const { updateBooking } = useBooking();
  const { _id, ltSpecific, participantCount } = booking;

  const [teamColor, setTeamColor] = useState('#ffffff');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const colorCalc = id => {
    if (id === 0) return 'orange';
    if (id === 1) return 'green';
    return '#ffffff';
  };

  useEffect(() => {
    if (ltSpecific?.playerGroupID !== undefined) {
      setTeamColor(colorCalc(ltSpecific.playerGroupID));
    } else {
      setTeamColor('#ffffff');
    }
  }, [ltSpecific?.playerGroupID, booking._id]);

  const handleClick = e => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const updatePlayerGroupID = async newId => {
    try {
      const update = { ltSpecific: { playerGroupID: newId } };

      const result = await updateBooking(_id, update);

      if (result && result.ltSpecific && result.ltSpecific.playerGroupID !== undefined) {
        const newColor = colorCalc(result.ltSpecific.playerGroupID);
        setTeamColor(newColor);

        // Update the local state with only the changed fields
        updateBookingState(_id, update);
        handleClose();
      } else {
        toast.error('Fehler beim Aktualisieren des Lasertag-Teams');
        console.error('Invalid response format:', result);
      }
    } catch (error) {
      toast.error('Fehler beim Aktualisieren des Lasertag-Teams');
      console.error('Error updating Regiondo booking:', error);
    }
  };

  return (
    <RegiondoBookingCardBase
      booking={booking}
      color={teamColor}
      topOffset={slotMode ? 64 : 40}
      iconProps={{ participantCount, slotMode, color: teamColor, onGreaterThanClick: handleClick }}
    >
      {slotMode && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ 'aria-labelledby': 'basic-button' }}
        >
          <MenuItem
            sx={{ color: 'orange', fontWeight: 'bold' }}
            onClick={e => {
              e.stopPropagation();
              updatePlayerGroupID(0);
            }}
          >
            Orange
          </MenuItem>
          <MenuItem
            sx={{ color: 'green', fontWeight: 'bold' }}
            onClick={e => {
              e.stopPropagation();
              updatePlayerGroupID(1);
            }}
          >
            Green
          </MenuItem>
        </Menu>
      )}
    </RegiondoBookingCardBase>
  );
}

export default BookingCardLasertag;
